<template>
	<OnboardingFormStep :commit="commit">

		<template #heading>
			<h1 class="onboarding-step-heading">Here's a little more about me...</h1>
		</template>
		<div class="grid gap-24">
			<SelectField v-if="plan.showAnnualEventsCreated" v-model="profile.annualEventsCreated" :required="requireAnnualEventsCreated">
				<template #label>
					How many weddings or events do you hire help for annually?
					<span v-if="!requireAnnualEventsCreated" class="optional">Optional</span>
				</template>
				<template #options>
					<option value="" disabled>Select one...</option>
					<option value="None">None</option>
					<option value="1-15">1-15</option>
					<option value="16-50">16-50</option>
					<option value="51-100">51-100</option>
					<option value="100+">100+</option>
				</template>
			</SelectField>
			<SelectField v-if="plan.showAnnualEventsWorked" v-model="profile.annualEventsWorked" :required="requireAnnualEventsWorked">
				<template #label>
					How many weddings or events do you shoot each year?
					<span v-if="!requireAnnualEventsWorked" class="optional">Optional</span>
				</template>
				<template #options>
					<option value="" disabled>Select one...</option>
					<option value="None">None</option>
					<option value="1-15">1-15</option>
					<option value="16-50">16-50</option>
					<option value="51-100">51-100</option>
					<option value="100+">100+</option>
				</template>
			</SelectField>
			<SelectField v-if="plan.showAnnualGrossRevenue" v-model="profile.annualGrossRevenue" :required="requireAnnualGrossRevenue">
				<template #label>
					What is your estimated annual gross revenue (from photography/videography)?
					<span v-if="!requireAnnualGrossRevenue" class="optional">Optional</span>
				</template>
				<template #options>
					<option value="" disabled>Select one...</option>
					<option value="$0-$10,000">$0-$10,000</option>
					<option value="$10,001-$25,000">$10,001-$25,000</option>
					<option value="$25,001-$50,000">$25,001-$50,000</option>
					<option value="$50,001-$100,000">$50,001-$100,000</option>
					<option value="$100,001-$200,000">$100,001-$200,000</option>
					<option value="$200,001-$400,000">$200,001-$400,000</option>
					<option value="$400,001+">$400,001+</option>
				</template>
			</SelectField>
			<NumberField v-if="plan.showYearsInBusiness" v-model="profile.yearsInBusiness" :required="requireYearsInBusiness" min="0" step="1">
				How many years have you been in business?
				<span v-if="!requireYearsInBusiness" class="optional">Optional</span>
			</NumberField>
		</div>
	</OnboardingFormStep>
</template>

<script>
import onboarding from '@/mixins/onboarding';

export default {
  name: 'OnboardingSurvey',
  mixins: [onboarding],
  onboardingStep: {
    isApplicable: ({ plan }) =>
      plan &&
      (plan.showAnnualEventsCreated ||
        plan.showAnnualEventsWorked ||
        plan.showAnnualGrossRevenue ||
        plan.showYearsInBusiness),
    isCompleted: ({ plan, profile }) =>
      plan && 
      profile && 
      (plan.showAnnualEventsCreated == 'optional' || !plan.showAnnualEventsCreated || profile.annualEventsCreated) &&
      (plan.showAnnualEventsWorked == 'optional' || !plan.showAnnualEventsWorked || profile.annualEventsWorked) &&
      (plan.showAnnualGrossRevenue == 'optional' || !plan.showAnnualGrossRevenue || profile.annualGrossRevenue) &&
      (plan.showYearsInBusiness == 'optional' || !plan.showYearsInBusiness || profile.yearsInBusiness != null),
    requires: ({ plan, profile }) => plan && profile,
  },
  computed: {
    requireAnnualEventsCreated() {
      return this.isFieldRequired(this.plan.showAnnualEventsCreated);
    },
    requireAnnualEventsWorked() {
      return this.isFieldRequired(this.plan.showAnnualEventsWorked);
    },
    requireAnnualGrossRevenue() {
      return this.isFieldRequired(this.plan.showAnnualGrossRevenue);
    },
    requireYearsInBusiness() {
      return this.isFieldRequired(this.plan.showYearsInBusiness);
    },
  },
  methods: {
    /**
     * @returns {Promise<boolean>}
     */
    async commit() {
      /** @type {(typeof this) & import('@/mixins/onboarding').OnboardingComponent} */
      const { plan, profile } = this;
      if (!plan || !profile) {
        return false;
      }
      /** @type {ProfilePatch} */
      const payload = Object.create(null);
      if (plan.showAnnualEventsCreated) {
        payload.annualEventsCreated = profile.annualEventsCreated;
      }
      if (plan.showAnnualEventsWorked) {
        payload.annualEventsWorked = profile.annualEventsWorked;
      }
      if (plan.showAnnualGrossRevenue) {
        payload.annualGrossRevenue = profile.annualGrossRevenue;
      }
      if (plan.showYearsInBusiness) {
        payload.yearsInBusiness = profile.yearsInBusiness;
      }
      if (Object.keys(payload).length) {
        await this.$store.dispatch('profiles/updateActiveProfile', payload);
      }

      return true;
    },
    /**
     * @param {boolean | 'optional' | 'required'} value
     * @returns {boolean}
     */
    isFieldRequired(value) {
      return value === 'required';
    },
  },
  watch: {
    experience() {
      this.error = null;
    },
  },
};
</script>
